import * as React from "react";
import Button from "@mui/material/Button";
import { styled } from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
// import CloseIcon from "@mui/icons-material/Close";
import DropdownInput from "../DropdownInput";
import { useDispatch } from "react-redux";
import { useFormik } from "formik";
import { myProfileAccounValidator } from "../../../services/validatior/formValidator/myProfileAccounValidator";
import { updateProfile } from "../../../redux/reducers/authSlice";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { TextField } from "@mui/material";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));

export default function EditModalAccount({
  isOpen,
  setIsOpen,
  title,
  myprofile,
}) {
  const dispatch = useDispatch();
  const editProfileAccountFormik = useFormik({
    initialValues: myProfileAccounValidator(myprofile, "initialValues"),
    validationSchema: myProfileAccounValidator(myprofile, "validationSchema"),
    onSubmit: async (values) => {
      let body = {
        ...values,
        name: `${values.fname} ${values.lname}`,
      };
      dispatch(updateProfile({ values: body, dispatch: dispatch }));

      setIsOpen(false);
    },
  });
  const handleClose = () => {
    setIsOpen(false);
  };

  return (
    <React.Fragment>
      <BootstrapDialog
        className="editmodal-wrap"
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={isOpen}
      >
        <DialogTitle
          sx={{ m: 0, p: 2 }}
          id="customized-dialog-title"
          className="editmodal-heading"
        >
          {title}
        </DialogTitle>
        <form onSubmit={editProfileAccountFormik.handleSubmit}>
          <DialogContent className="edit-Modal-body" dividers>
            <div style={{ maxHeight: "65vh" }}>
              <div className="row">
                <div className="col-lg-6 col-md-12">
                  <div className="form-group">
                    <label>First Name</label>
                    <input
                      type="text"
                      name="fname"
                      id="fname"
                      className="form-control"
                      placeholder=""
                      onChange={editProfileAccountFormik.handleChange}
                      value={editProfileAccountFormik.values.fname}
                    />
                    <p className="form-error-message">
                      {editProfileAccountFormik.touched.fname &&
                        editProfileAccountFormik.errors.fname}
                    </p>
                  </div>
                </div>
                <div className="col-lg-6 col-md-12">
                  <div className="form-group">
                    <label>Last Name</label>
                    <input
                      type="text"
                      name="lname"
                      id="lname"
                      className="form-control"
                      placeholder=""
                      onChange={editProfileAccountFormik.handleChange}
                      value={editProfileAccountFormik.values.lname}
                    />
                    <p className="form-error-message">
                      {editProfileAccountFormik.touched.lname &&
                        editProfileAccountFormik.errors.lname}
                    </p>
                  </div>
                </div>
                <div className="col-lg-6 col-md-12">
                  <div className="form-group">
                    <label>Mobile Number</label>
                    <input
                      type="tel"
                      name="phoneNumber"
                      id="phoneNumber"
                      className="form-control"
                      placeholder=""
                      onChange={editProfileAccountFormik.handleChange}
                      value={editProfileAccountFormik.values.phoneNumber}
                    />
                    <p className="form-error-message">
                      {editProfileAccountFormik.touched.phoneNumber &&
                        editProfileAccountFormik.errors.phoneNumber}
                    </p>
                  </div>
                </div>
                <div className="col-lg-6 col-md-12">
                  <div className="form-group">
                    <label>Email</label>
                    <input
                      type="email"
                      name="email"
                      id="email"
                      disabled
                      className="form-control"
                      placeholder=""
                      onChange={editProfileAccountFormik.handleChange}
                      value={editProfileAccountFormik.values.email}
                    />
                    <p className="form-error-message">
                      {editProfileAccountFormik.touched.email &&
                        editProfileAccountFormik.errors.email}
                    </p>
                  </div>
                </div>
                <div className="col-lg-6 col-md-12">
                  <div className="form-group">
                    <label>Date of birth</label>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DatePicker
                        sx={{ width: "100%" }}
                        className={`w-full`}
                        format="DD/MM/YYYY"
                        onChange={(newValue) =>
                          editProfileAccountFormik.setFieldValue(
                            "dob",
                            new Date(newValue).toISOString()
                          )
                        }
                        value={dayjs(editProfileAccountFormik.values.dob)}
                        renderInput={(params) => (
                          <TextField {...params} className={`!p-0`} />
                        )}
                      />
                    </LocalizationProvider>
                    <p className="form-error-message">
                      {editProfileAccountFormik.touched.dob &&
                        editProfileAccountFormik.errors.dob}
                    </p>
                  </div>
                </div>
                <div className="col-lg-6 col-md-12">
                  <div className="form-group">
                    <DropdownInput
                      label={"Property Type"}
                      options={[
                        { value: "HDB", option: "HDB" },
                        { value: "Condo", option: "Condo" },
                        { value: "Landed", option: "Landed" },
                      ]}
                      onChange={editProfileAccountFormik.handleChange}
                      name="property_type"
                      id="property_type"
                      value={editProfileAccountFormik.values.property_type}
                    />
                    <p className="form-error-message">
                      {editProfileAccountFormik.touched.property_type &&
                        editProfileAccountFormik.errors.property_type}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </DialogContent>
          <DialogActions>
            <Button className="btn" autoFocus type="submit">
              Save changes
            </Button>
          </DialogActions>
        </form>
      </BootstrapDialog>
    </React.Fragment>
  );
}
